import { render, staticRenderFns } from "./ChangeSettingsAlert.vue?vue&type=template&id=4fe52a87&"
import script from "./ChangeSettingsAlert.vue?vue&type=script&lang=js&"
export * from "./ChangeSettingsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports